function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from 'lodash/merge';
function stripUnit(value) {
  return Number(value.replace('px', ''));
}
export function findTick(x, ticks) {
  return Object.values(ticks).find(tick => {
    var _tick$label;
    // @ts-expect-error what is xy? who knows
    return tick.pos > -1 && Math.ceil(x) === Math.ceil(tick === null || tick === void 0 || (_tick$label = tick.label) === null || _tick$label === void 0 ? void 0 : _tick$label.xy.x);
  });
}
export var highlightXAxisLabel = _ref => {
  var {
    theme,
    chartRef,
    tickRef
  } = _ref;
  return {
    point: {
      events: {
        mouseOver: e => {
          if (!chartRef.current) {
            return;
          }
          var {
            clientX
          } = e;
          var {
            plotLeft
          } = chartRef.current.chart;
          var {
            ticks
          } = chartRef.current.chart.xAxis[0];
          var pos = clientX + plotLeft;
          var tick = findTick(pos, ticks);
          if (tick && tick.label) {
            tickRef.current = tick;
            tick.label.css({
              color: theme.palette.foreground.default
            });
          }
        },
        mouseOut: () => {
          if (!tickRef.current) {
            return;
          }
          var {
            current: tick
          } = tickRef;
          if (tick && tick.label) {
            tick.label.css({
              color: theme.palette.foreground.light
            });
            tickRef.current = null;
          }
        }
      }
    }
  };
};
export var legend = _ref2 => {
  var {
    group = false,
    theme
  } = _ref2;
  var size4 = stripUnit(theme.layout.size4); // 16px without the unit

  return {
    enabled: group,
    itemHoverStyle: {
      color: theme.palette.foreground.default
    },
    itemStyle: {
      color: theme.palette.foreground.default,
      fontSize: theme.typography.size0,
      // @ts-expect-error string, number, number, string
      height: theme.layout.size4,
      lineHeight: theme.typography.lineHeight1
    },
    navigation: {
      style: {
        color: theme.palette.foreground.default,
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      }
    },
    padding: size4,
    symbolHeight: size4,
    symbolRadius: stripUnit(theme.borderRadius2),
    symbolWidth: size4,
    useHTML: true
  };
};
export var tooltip = _ref3 => {
  var {
    theme,
    shared = false
  } = _ref3;
  var tooltipTitleStyle = "font-family: ".concat(theme.typography.family0, "; font-size: ").concat(theme.typography.size1, "; line-height: ").concat(theme.typography.lineHeight2, ";");
  var tooltipSubtitleStyle = "font-family: ".concat(theme.typography.family0, "; font-size: ").concat(theme.typography.size0, "; line-height: ").concat(theme.typography.lineHeight1);
  return _objectSpread(_objectSpread({
    animation: false,
    backgroundColor: theme.colorChartTooltipBackground,
    borderRadius: stripUnit(theme.borderRadius3),
    borderWidth: 0,
    headerFormat: '',
    useHTML: true,
    padding: 0,
    formatter() {
      if (shared) {
        var _this$points;
        return "<div style=\"padding: ".concat(theme.layout.size1, " ").concat(theme.layout.size2, "; min-width: 80px\">\n        <span style=\"").concat(tooltipTitleStyle, "\">").concat(this.x, "</span>\n        ").concat(this === null || this === void 0 || (_this$points = this.points) === null || _this$points === void 0 ? void 0 : _this$points.map(p => "<div style=\"display: block; ".concat(tooltipSubtitleStyle, "\">\n                <span>").concat(p.series.name, ": </span>\n                <span>").concat(p.y, "</span>\n              </div>")).join(''), "\n      </div>");
      }
      return "<span style=\"padding: 0 ".concat(theme.layout.size2, "; ").concat(tooltipSubtitleStyle, "\">").concat(this.point.y, "</span>");
    }
  }, !shared && {
    positioner(labelWidth, labelHeight, point) {
      return {
        x: point.plotX + this.chart.plotLeft - labelWidth / 2,
        y: this.chart.plotTop - 16
      };
    }
  }), {}, {
    shared,
    shadow: false,
    shape: 'square',
    style: {
      color: theme.colorChartTooltipForeground,
      fontSize: theme.typography.size0,
      lineHeight: theme.typography.lineHeight1
    }
  });
};
export var xAxis = _ref4 => {
  var {
    group = false,
    theme,
    shared = false
  } = _ref4;
  return _objectSpread(_objectSpread({
    lineColor: theme.colorChartLine
  }, !shared && {
    crosshair: {
      color: group ? 'transparent' : theme.colorChartCrosshair,
      width: group ? 0 : 2
    }
  }), {}, {
    labels: {
      style: {
        color: theme.palette.foreground.light,
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      }
    }
  });
};
export var yAxis = _ref5 => {
  var {
    theme
  } = _ref5;
  return {
    gridLineColor: theme.colorChartLine,
    labels: {
      style: {
        color: theme.palette.foreground.light,
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      }
    },
    title: {
      text: null,
      style: {
        color: theme.palette.foreground.light,
        fontFamily: theme.typography.family0,
        fontSize: theme.typography.size0,
        lineHeight: theme.typography.lineHeight1
      }
    }
  };
};
export var mergeOptions = (defaultOption, option) => {
  var _option$tooltip, _option$tooltip2, _option$tooltip3;
  var hasFooterFormat = Boolean(option === null || option === void 0 || (_option$tooltip = option.tooltip) === null || _option$tooltip === void 0 ? void 0 : _option$tooltip.footerFormat);
  var hasHeaderFormat = Boolean(option === null || option === void 0 || (_option$tooltip2 = option.tooltip) === null || _option$tooltip2 === void 0 ? void 0 : _option$tooltip2.headerFormat);
  var hasPointFormat = Boolean(option === null || option === void 0 || (_option$tooltip3 = option.tooltip) === null || _option$tooltip3 === void 0 ? void 0 : _option$tooltip3.pointFormat);
  if (hasFooterFormat || hasHeaderFormat || hasPointFormat) {
    var defaultFormatOptions = {
      tooltip: {
        followPointer: true,
        followTouchMove: false,
        formatter: false,
        positioner: false
      },
      xAxis: {
        crosshair: {
          color: 'transparent'
        }
      }
    };
    return merge(defaultOption, defaultFormatOptions, option);
  }
  return merge(defaultOption, option);
};